import { takeLatest, put, fork } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import {
  loadingPharmacyDropDown,
  setPharmacyDropDown,
} from "../Slice/PharmacyDropDownSlice";
import { PharmacyHistoryDropDownValues } from "../../Apis/AuthApiServices";

function* onLoadNotificationAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  let patientId: any = sessionStorage.getItem("patientId");
  params.append("doctorId", doctorId);
  params.append("patientId", patientId);
  params.append("prescriptionType", "newRx");
  params.append("pharmacyCode", "");
  try {
    const result: AxiosResponse = yield PharmacyHistoryDropDownValues(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setPharmacyDropDown({
          PharmacyDropDownData: result?.data?.response,
          error: false,
          isLoading: false,
        })
      );
    } else {
      yield put(
        setPharmacyDropDown({
          PharmacyDropDownData: [],
          error: true,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error) {
    yield put(
      setPharmacyDropDown({
        PharmacyDropDownData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadPharmacyDropDown() {
  yield takeLatest(loadingPharmacyDropDown.type, onLoadNotificationAsync);
}

const PharmacyDropDownSaga = [fork(onLoadPharmacyDropDown)];

export default PharmacyDropDownSaga;
